import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { AgentService } from '../services/agent.service';
import { AgentHierarchySearchHandler } from './agent-hierarchy-search.handler';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'sym-agent-hierarchy-search',
  templateUrl: './agent-hierarchy-search.component.html',
  styleUrls: ['./agent-hierarchy-search.component.scss'],
})
export class AgentHierarchySearchComponent extends AgentHierarchySearchHandler {
  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
